import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import {
  ICadastrarVoucherGateway,
  ICadastrarVoucherGatewayParams
} from "../ports/CadastrarVoucherGateway";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import Result from "@/core/common/Result";

@injectable()
export class CadastrarVoucherGatewayAdapter
  implements ICadastrarVoucherGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly client!: HttpClient;

  async cadastrar(
    params: ICadastrarVoucherGatewayParams
  ): Promise<Result<void>> {
    try {
      const response = await this.client.post<IDefaultContabilResponse<void>>({
        url: `/v1/contabil/voucher/${params.voucherId}/aplicar`,
        body: {
          ...params
        }
      });
      if (response.statusCode !== 200 || response.body?.code !== 200)
        return Result.fail("Não foi possível cadastrar o voucher");

      return Result.ok();
    } catch (_e) {
      return Result.fail("Ocorreu um erro inesperado ao salvar o cadastro");
    }
  }
}
